import $ from 'gridstrap/lib/gs-zepto';
declare var Chart;

export class GSDoughnutChart {

	//
	// Properties
	//

	private root;
	private canvas;
	private chart;
	private legend;

	get data()     { return JSON.parse(this.root.find('script').html() || '{}'); }
	get colors()   { return this.root.data('gsDoughnutChartColors').split(' '); }
	get labelKey() { return this.root.data('gsDoughnutChartLabelKey'); }
	get valueKey() { return this.root.data('gsDoughnutChartValueKey'); }
	get libUrl()   { return this.root.data('gsDoughnutChartLibUrl'); }

	//
	// Methods
	//

	render() {
		this.chart = new Chart(this.canvas, {
			data: this.parseData(),
			type: 'doughnut',
			options: {
				responsive: true,
				maintainAspectRatio: false,
				animation: {
					animateScale: true,
					animateRotate: true
				},
				legend: false,
				legendCallback: this.generateLegend,
				tooltips: {
					callbacks: { label: this.percentageLabel }
				}
			}
		});

		this.legend.html(
			this.chart.generateLegend()
		);
	}

	private loadLibrary() {
		return new Promise((resolve, reject) => {
			$['ajax']({
				dataType: 'script',
				cache: true,
				url: this.libUrl,
				success: resolve
			});
		});
	}

	private parseData() {
		let data = {
			labels: [],
			datasets: [{ data: [], backgroundColor: [] }]
		};

		for (let i = 0; i < this.data.length; i++) {
			data.labels.push(this.data[i][this.labelKey]);
			data.datasets[0].data.push(this.data[i][this.valueKey]);
			data.datasets[0].backgroundColor.push(this.colors[i]);
		}

		return data;
	}

	private generateLegend(chart) {
		let html = [];
		let item = chart.data.datasets[0];
		for (let i = 0; i < item.data.length; i++) {
			html.push(`
				<div class="gs-DoughnutChart-legendItem">
					<span class="gs-DoughnutChart-legendColorBox" style="background-color: ${item.backgroundColor[i]}"></span>
					<span class="gs-DoughnutChart-legendLabel">
						<span class="gs-DoughnutChart-legendLabelText">${chart.data.labels[i]}</span>
						<span class="gs-DoughnutChart-legendLabelPerc">${item.data[i]}%</span>
					</span>
				</div>
			`);
		}
		return html.join('');
	}

	private percentageLabel(tooltipItem, data) {
		let dataset = data.datasets[tooltipItem.datasetIndex];
		let label = data.labels[tooltipItem.index];
		let percentage = dataset.data[tooltipItem.index];
		return ` ${label}: ${percentage}%`;
	}

	//
	// Initializations & Event Listeners
	//

	constructor(root) {
		this.root = $(root);
		this.canvas = this.root.find('canvas');
		this.legend = this.root.find('.gs-DoughnutChart-legend');
		this.loadLibrary().then(() => this.render());
	}
}
